export enum ELabelColor {
  Gray = 'gray',
  DarkGray = 'dark-gray',
  Green = 'green',
  DarkGreen = 'darkGreen',
  Red = 'red',
  Yellow = 'yellow',
  /** Оранжевый с иконкой процента */
  OrangePercent = 'orangePercent',
  /** Синий с иконкой Циан */
  Blue = 'blue',
  /** Синий без иконки Циан */
  SimpleBlue = 'simpleBlue',
  SimpleBlueIconed = 'simpleBlueIconed',
  BlueVerifiedByCian = 'blueVerifiedByCian',
  BlueInstantBooking = 'blueInstantBooking',
  /** Синий с иконкой CPD */
  BlueCpdLabel = 'blueCpdLabel',
  /** Фиолетовый с иконкой */
  Purple = 'purple',
  Orange = 'orange',
  PurpleEarlyAccess = 'purpleEarlyAccess',

  /**
   * Код появился к проекту "Чёрная пятница" для компании "Этажи".
   * @todo: удалить в задаче CD-250843
   */
  RedEtazhiBlackFriday = 'redEtazhiBlackFriday',
}

export type TLabelColor = `${ELabelColor}`;

export interface ILabelTooltip {
  description: React.ReactNode;
  title?: string;
  link?: string;
  linkText?: string;
  onOpen?: () => void;
}

export interface ILabel {
  color: ELabelColor;
  text: string;
  tooltip?: ILabelTooltip;
  onClick?: () => void;
}
